module.exports = __webpack_public_path__ + "static/media/ARG.60dbde5b.jpg";